'use client';

import { createContext, useContext, use } from 'react';

const missingCampaignProvider = Symbol('missingCampaignProvider');
const CampaignContext = createContext(missingCampaignProvider);

export const CampaignProvider = ({ campaignPromise, children }) => {
  const campaign = use(campaignPromise);

  return (
    <CampaignContext.Provider value={campaign}>
      {children}
    </CampaignContext.Provider>
  );
};

export const useCampaign = () => {
  const context = useContext(CampaignContext);
  if (context === missingCampaignProvider) {
    throw new Error('useCampaign must be used within a CampaignProvider');
  }
  return context;
};
